// Margin in px. Added to the form on each nesting level
const NESTING_MARGIN = 16;
const NESTING_MARGIN_EDIT_MODE = 19;

const QUESTION_TYPES = {
  RADIO: "radio",
  CHECKBOX: "checkbox",
  LIST: "list",
};

const ANSWER_TYPES = {
  TEXT: "text",
  DURATION: "duration",
  NUMERIC: "numeric",
  TEMPERATURE: "temperature",
  CONTAINER_NUMBER: "containerNumber",
  LABEL: "label",
};

const NODE_TYPES = { ...QUESTION_TYPES, ...ANSWER_TYPES };

let rootElement = undefined;
let editElement = undefined;
let formElement = undefined;
let formSelector = undefined;
let json = undefined;

window.addEventListener("DOMContentLoaded", () => {
  rootElement = document.querySelector("#show-questionnaire");
  if (!rootElement) {
    return;
  }

  json = JSON.parse(rootElement.getAttribute("data-json"));
  formSelector = rootElement.getAttribute("data-form-selector");
  editElement = document.querySelector("#edit-questionnaire");
  formElement = document.querySelector(formSelector);
  if (rootElement) {
    renderForm(json, rootElement);
  }
  if (formElement) {
    formElement.innerHTML = JSON.stringify(json, undefined, 2);
  }
  if (editElement) {
    listenToJSONChanges(rootElement, "data-json");
    renderForm(json, editElement, { editMode: true });
  }
});

function listenToJSONChanges(element, attribute) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes") {
        renderForm(json, rootElement);

        // Don't rerender if any input is in focus because it will drop the focus
        // and create bad UI for typing multiple characters
        if (isAllTextInputsBlurred()) {
          renderForm(json, editElement, { editMode: true });
        }

        if (formElement) {
          formElement.innerHTML = JSON.stringify(json, undefined, 2);
        }
      }
    });
  });

  observer.observe(element, { attributes: true });
}

const isAllTextInputsBlurred = () => {
  const inputs = document.querySelectorAll(`#edit-questionnaire input`);
  let isBlurred = true;
  inputs.forEach((input) => {
    if (document.activeElement === input) {
      isBlurred = false;
      return;
    }
  });

  return isBlurred;
};

function renderForm(json, parentElement, options = {}) {
  const nestingLevel = options.nestingLevel || 0;
  const editMode = options.editMode || false;
  const parentType = options.parentType;
  const nestingMargin = editMode ? NESTING_MARGIN_EDIT_MODE : NESTING_MARGIN;
  const isRoot = nestingLevel === 0;

  if (isRoot) {
    parentElement.innerHTML = null;
  }

  if (isQuestionType(json)) {
    parentElement.appendChild(
      renderQuestion(json, options.parentName, { editMode, parentType, isRoot })
    );
    const optionsElement = document.createElement("div");
    optionsElement.style.setProperty("margin-left", `${nestingMargin}px`);
    const nextNestingLevel = nestingLevel + 1;

    json.options.forEach((option) => {
      if (isQuestionType(option)) {
        renderForm(option, optionsElement, {
          nestingLevel: nextNestingLevel,
          parentType: json.optionsType,
          parentName: json.name,
          editMode,
        });
      } else if (isLabelType(option)) {
        optionsElement.style.setProperty(
          "margin-left",
          `${editMode ? nestingMargin - 20 : nestingMargin * 2 - 17}px`
        );
        // optionsElement.style.setProperty('background-color', 'red')
        optionsElement.appendChild(
          renderLabel(option, {
            parentName: json.name,
            parentType: json.optionsType,
            editMode,
            isRoot: false,
          })
        );
      } else if (isLabelWithFollowUpType(option)) {
        if (isLabelWithEmptyFollowUpType(option)) {
          // Similarly to below, a not-so-pretty
          // check must be done here to check if child's
          // followUp is empty. If it is, it means it was
          // deleted by the editor and must be cleaned up.
          delete option.followUp;
        }

        optionsElement.appendChild(
          renderLabel(option, {
            parentName: json.name,
            parentType: json.optionsType,
            editMode,
            isRoot: false,
          })
        );

        if (option.followUp) {
          const wrapper = document.createElement("div");
          wrapper.style.setProperty(
            "margin-left",
            `${nestingLevel > 0 ? nestingMargin : 0}px`
          );
          renderForm(option.followUp, wrapper, {
            nestingLevel: nextNestingLevel,
            parentType: NODE_TYPES["LABEL"],
            parentName: json.name,
            editMode,
          });
          optionsElement.append(wrapper);
        }
      } else if (isAnswerType(option)) {
        optionsElement.appendChild(
          renderAnswer(option, {
            parentName: json.name,
            parentType: json.optionsType,
            editMode,
            isRoot: false,
          })
        );
      } else if (isEmptyObject(option)) {
        // If any question was deleted in the editor,
        // it will leave empty brackets {} in the JSON.
        // Let's clear it up.
        json.options = json.options.filter((option) => {
          return !isEmptyObject(option);
        });
      } else {
        alert(
          `Dont know how to handle nested option ${JSON.stringify(
            option
          )}. Ask your developer to handle this option in questionnaires.js`
        );
      }
    });

    parentElement.style.setProperty(
      "margin-left",
      `${nestingLevel > 0 ? nestingMargin : 0}px`
    );
    parentElement.appendChild(optionsElement);
  } else if (isAnswerType(json) || isLabelType(json)) {
    const wrapper = document.createElement("div");
    wrapper.appendChild(
      renderAnswer(json, {
        parentName: json.name,
        parentType,
        editMode,
        isRoot,
      })
    );
    wrapper.style.setProperty(
      "margin-left",
      `${
        nestingLevel > 0 && parentType !== NODE_TYPES["LABEL"]
          ? nestingMargin
          : 0
      }px`
    );
    parentElement.appendChild(wrapper);
  } else {
    alert(
      `Dont know how to handle ${JSON.stringify(
        json
      )}. Ask your developer to handle this option in questionnaires.js`
    );
  }
}

const isQuestionType = (json) => {
  const keys = ["label", "name", "optionsType", "options"];

  return keys.sort().toString() === Object.keys(json).sort().toString();
};

const isAnswerType = (json) => {
  const keys = ["label", "name", "type"];

  return keys.sort().toString() === Object.keys(json).sort().toString();
};

const isLabelType = (json) => {
  const keys = ["label", "name"];

  return keys.sort().toString() === Object.keys(json).sort().toString();
};

const isEmptyObject = (json) => {
  return JSON.stringify(json) === "{}";
};

const isLabelWithFollowUpType = (json) => {
  const keys = ["label", "name", "followUp"];

  return keys.sort().toString() === Object.keys(json).sort().toString();
};

const isLabelWithEmptyFollowUpType = (json) => {
  return (
    isLabelWithFollowUpType(json) && Object.keys(json.followUp).length === 0
  );
};

const renderEditLabelAndUpdateJSON = (json, { parentName, parentType }) => {
  const input = document.createElement("input");
  input.value = json.label;
  input.name = parentName;
  input.classList.add("input", "editor-input");
  input.type = "text";
  input.oninput = (event) => {
    json.label = event.target.value;
    rootElement.setAttribute("data-json", JSON.stringify(json));
  };

  const wrapper = document.createElement("div");
  wrapper.classList.add("input-wrapper");
  if (parentType && ["radio", "checkbox"].includes(parentType)) {
    const checkbox = document.createElement("input");
    checkbox.type = parentType;
    checkbox.disabled = true;
    wrapper.appendChild(checkbox);
  }
  wrapper.appendChild(input);

  return wrapper;
};

const renderEditQuestionTypeAndUpdateJSON = (json, { parentType, isRoot }) => {
  const select = document.createElement("select");

  Object.keys(NODE_TYPES).forEach((key) => {
    if (
      parentType === NODE_TYPES["LIST"] &&
      NODE_TYPES[key] === NODE_TYPES["LABEL"]
    ) {
      // Makes no sense to have LABEL as a child of LIST
      return;
    }

    if (
      [NODE_TYPES["RADIO"], NODE_TYPES["CHECKBOX"]].includes(parentType) &&
      NODE_TYPES[key] !== NODE_TYPES["LABEL"]
    ) {
      // Only LABEL allowed for RADIO and CHECKBOX types
      return;
    }

    if (isRoot && NODE_TYPES[key] === NODE_TYPES["LABEL"]) {
      // Makes no sense to have LABEL at root level
      return;
    }

    if (
      parentType === NODE_TYPES["LABEL"] &&
      NODE_TYPES[key] === NODE_TYPES["LABEL"]
    ) {
      // If parent is a LABEL it means current node is a followUp question that can't be LABEL
      return;
    }

    const option = document.createElement("option");
    option.value = NODE_TYPES[key];
    option.text = key;
    select.appendChild(option);
  });

  select.classList.add("input", "editor-input");
  select.value = json.optionsType || json.type || "label";
  select.onchange = (event) => {
    const oldType = json.optionsType || json.type;
    const newType = event.target.value;
    const wasQuestion = Object.values(QUESTION_TYPES).includes(
      json.optionsType
    );
    const wasAnswer = Object.values(ANSWER_TYPES).includes(json.type);
    const willBeQuestion = Object.values(QUESTION_TYPES).includes(newType);
    const willBeAnswer =
      Object.values(ANSWER_TYPES).includes(newType) &&
      newType !== ANSWER_TYPES["LABEL"];
    const willBeLabel = newType === ANSWER_TYPES["LABEL"];

    if (willBeLabel) {
      // Label is a special case that always removes all options,
      // optionTypes and doesn't want any input from the user.
      // It's represented as having only a label and a name,
      // no type, so we remove type as well.
      delete json.optionsType;
      delete json.options;
      delete json.followUp;
      delete json.type;

      rootElement.setAttribute("data-json", JSON.stringify(json));
      return;
    }

    if (willBeQuestion) {
      json.optionsType = newType;

      if (!wasQuestion) {
        delete json.type;
        delete json.followUp;
      }

      if (newType === NODE_TYPES["LIST"]) {
        // No direct conversion from RADIO or CHECKBOX to LIST, so overwrite options with a TEXT
        json.options = [{ label: "Question", name: "question", type: "text" }];
      } else if (
        ![NODE_TYPES["RADIO"], NODE_TYPES["CHECKBOX"]].includes(oldType) &&
        [NODE_TYPES["RADIO"], NODE_TYPES["CHECKBOX"]].includes(newType)
      ) {
        // No conversion from LIST to RADIO or CHECKBOX, so overwrite options with a LABEL
        json.options = [{ label: "Answer", name: "question" }];
      } else if (!json.options) {
        json.options = [];
      }

      rootElement.setAttribute("data-json", JSON.stringify(json));
      return;
    }

    if (willBeAnswer) {
      json.type = newType;

      if (!wasAnswer) {
        delete json.optionsType;
        delete json.options;
        delete json.followUp;
      }

      rootElement.setAttribute("data-json", JSON.stringify(json));
      return;
    }
  };

  return select;
};

const renderAddAnswerAndUpdateJSON = (json) => {
  const button = document.createElement("button");
  button.classList.add("button", "button-add");
  button.innerHTML = "Add answer";
  button.onclick = (event) => {
    if (
      [NODE_TYPES["RADIO"], NODE_TYPES["CHECKBOX"]].includes(json.optionsType)
    ) {
      json.options.push({ label: "Answer", name: json.name });
    } else if (json.optionsType === NODE_TYPES["LIST"]) {
      json.options.push({ label: "Question", name: json.name, type: "text" });
    }

    rootElement.setAttribute("data-json", JSON.stringify(json));
  };

  return button;
};

const renderAddFollowUpAndUpdateJSON = (json) => {
  const button = document.createElement("button");
  button.classList.add("button", "button-add");
  button.innerHTML = "Add Follow up";
  button.onclick = (event) => {
    json.followUp = {
      label: "Follow up question",
      name: `${json.name}_follow_up`,
      type: "text",
    };

    rootElement.setAttribute("data-json", JSON.stringify(json));
  };

  return button;
};

const renderDeleteFollowUpAndUpdateJSON = (json) => {
  const button = document.createElement("button");
  button.classList.add("button", "button-delete");
  button.innerHTML = "Remove Follow up";
  button.onclick = (event) => {
    delete json.followUp;

    rootElement.setAttribute("data-json", JSON.stringify(json));
  };

  return button;
};

const renderDeleteAnswerAndUpdateJSON = (json) => {
  const button = document.createElement("button");
  button.classList.add("button", "button-delete");
  button.innerHTML = "Remove";
  button.onclick = (event) => {
    Object.keys(json).forEach((key) => {
      delete json[key];
    });

    rootElement.setAttribute("data-json", JSON.stringify(json));
  };

  return button;
};

const renderQuestion = (json, parentName, { editMode, parentType, isRoot }) => {
  if (editMode) {
    const editLabel = renderEditLabelAndUpdateJSON(json, {
      parentName,
      parentType,
    });
    const editQuestionType = renderEditQuestionTypeAndUpdateJSON(json, {
      parentType,
      isRoot,
    });
    const addAnswer = renderAddAnswerAndUpdateJSON(json);
    const deleteAnswer = renderDeleteAnswerAndUpdateJSON(json);
    const wrapper = document.createElement("div");
    wrapper.classList.add("editor-input-wrapper");
    wrapper.appendChild(editLabel);
    wrapper.appendChild(editQuestionType);
    wrapper.appendChild(addAnswer);
    if (!isRoot) {
      wrapper.appendChild(deleteAnswer);
    }

    return wrapper;
  }

  return renderLabel(json, { parentName, parentType });
};

const renderAnswer = (json, { parentName, parentType, editMode, isRoot }) => {
  if (editMode) {
    const editLabel = renderEditLabelAndUpdateJSON(json, {
      parentName,
      parentType,
    });
    const editQuestionType = renderEditQuestionTypeAndUpdateJSON(json, {
      parentType,
      isRoot,
    });
    const deleteAnswer = renderDeleteAnswerAndUpdateJSON(json);
    const wrapper = document.createElement("div");
    wrapper.classList.add("editor-input-wrapper");
    wrapper.appendChild(editLabel);
    wrapper.appendChild(editQuestionType);
    if (!isRoot) {
      wrapper.appendChild(deleteAnswer);
    }
    return wrapper;
  }

  const option = renderLabel(json, { parentName, parentType });
  option.classList.add("answer");
  if (json.type === ANSWER_TYPES["TEXT"]) {
    const input = document.createElement("input");
    input.name = parentName;
    input.placeholder = "Type your answer...";
    input.type = "text";
    option.appendChild(input);
  } else if (json.type === ANSWER_TYPES["NUMERIC"]) {
    const input = document.createElement("input");
    input.name = parentName;
    input.placeholder = "Enter number...";
    input.type = "number";
    option.appendChild(input);
  } else if (json.type === ANSWER_TYPES["DURATION"]) {
    const input = document.createElement("input");
    input.name = parentName;
    input.placeholder = "Enter duration...";
    input.type = "number";
    option.appendChild(input);
  } else if (json.type === ANSWER_TYPES["TEMPERATURE"]) {
    const input = document.createElement("input");
    input.name = parentName;
    input.placeholder = "Enter temperature in C...";
    input.type = "temperature";
    option.appendChild(input);
  } else if (json.type === ANSWER_TYPES["CONTAINER_NUMBER"]) {
    const input = document.createElement("input");
    input.name = parentName;
    input.placeholder = "Scan container number";
    input.type = "ocr";
    option.appendChild(input);
  } else if (!json.type) {
    // Label type doesn't render any further input
  } else {
    alert(
      `Dont know how to handle answer type "${json.type}". Ask your developer to handle this option in questionnaires.js`
    );
  }

  return option;
};

const renderLabel = (json, { parentName, parentType, editMode, isRoot }) => {
  if (editMode) {
    const editLabel = renderEditLabelAndUpdateJSON(json, {
      parentName,
      parentType,
    });
    const editQuestionType = renderEditQuestionTypeAndUpdateJSON(json, {
      parentType,
      isRoot,
    });
    const addFollowUp = renderAddFollowUpAndUpdateJSON(json);
    const deleteFollowUp = renderDeleteFollowUpAndUpdateJSON(json);
    const deleteAnswer = renderDeleteAnswerAndUpdateJSON(json);
    const wrapper = document.createElement("div");
    wrapper.classList.add("editor-input-wrapper");
    wrapper.appendChild(editLabel);
    wrapper.appendChild(editQuestionType);
    if (json.followUp) {
      wrapper.appendChild(deleteFollowUp);
    } else {
      wrapper.appendChild(addFollowUp);
    }
    if (!isRoot) {
      wrapper.appendChild(deleteAnswer);
    }
    return wrapper;
  }

  if (
    parentType === NODE_TYPES["RADIO"] ||
    parentType === NODE_TYPES["CHECKBOX"]
  ) {
    const wrapper = document.createElement("div");
    const input = document.createElement("input");
    input.type = parentType;
    input.name = parentName;
    input.value = json.name;
    input.id = json.name;

    const label = document.createElement("label");
    label.appendChild(input);
    const labelText = document.createElement("span");
    labelText.innerHTML = json.label;
    label.appendChild(labelText);

    wrapper.appendChild(label);
    return wrapper;
  } else if (
    !parentType ||
    [NODE_TYPES["LIST"], NODE_TYPES["LABEL"]].includes(parentType)
  ) {
    const elem = document.createElement("div");
    elem.innerHTML = json["label"];
    elem.classList.add("input-wrapper-text");

    return elem;
  } else {
    alert(
      `Dont know how to handle optionType "${parentType}". Ask your developer to handle this option in questionnaires.js`
    );
  }
};
